<template>
    <div class="vtrend-licheng" :class="[nClass]">
        <!-- <Echart :id="'siteVtrendLicheng'" :options="options" :width="width" :height="height"></Echart> -->
        <div :id="id"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts5'
export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        nClass: {
            type: [Number, String],
            default: ''
        },
        series: {
            type: Array,
            default: () => { return [] }
        },
        xAxis: {
            type: Object,
            default: () => { return {} }
        },
        yAxis: {
            type: Object,
            default: () => { return {} }
        },
        colors: {
            type: Array,
            default: () => { return []}
        }
    },
    data() {
        return {
            // width: 166,
            // height: 110,
            options: {
                title: {
                    text: '近 30天',
                    textStyle: {
                        fontSize: 10,
                        color: '#ddd'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '12%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: this.xAxis.data,
                    axisPointer: {
                        type: 'shadow',
                    },
                    axisLabel: {
                        fontSize: 20,
                        rotate: 45,
                        color: '#fff',
                        textStyle: {
                            color: "#fff",
                        }
                    }
                }],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            fontSize: 20,
                            rotate: 45,
                            color: '#fff',
                            textStyle: {
                                color: "#fff",
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ["rgba(255, 255, 255, 0.15)"]
                            }
                        },
                        // axisLabel: {
                        //     formatter: '{value}'
                        // }
                    }
                ],
                series: [
                    {
                        name: this.yAxis.name,
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return value
                            }
                        },
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: this.colors[0] || '#60F5FF' },
                                { offset: 1, color: this.colors[1] || '#3FA5FF' }
                            ])
                        },
                        data: this.series[0]
                    }
                ]
            }
        }
    },
    mounted() {
        this.myCharts()
    },
    methods: {
        myCharts() {
            const _this = this
            const myCharts = echarts.init(document.getElementById(_this.id))
            // myCharts.resize({
            //     width: `${this.width}px`,
            //     height: `${this.height}px`
            // })
            myCharts.setOption(_this.options)
        }
    }
}
</script>

<style lang="scss" scoped>
.vtrend-licheng {
    width: 100%;
    height: 280px;
    &.right1 {
        height: 520px;
    }
    > div {
        width: 100%;
        height: 100%;
    }
}
</style>